import { chooseReducer } from '@/utils/draftHelper';
import initialState from './state';
import updateVocabulariesState from './vocabularies';

export default (state = initialState, action) => chooseReducer(state, action, updateVocabulariesState);
